export default {
  SET_CATALOG_LOADING(state, loading) {
    state.catalogLoading = loading
  },
  SET_CATALOG_ERROR(state, error) {
    state.catalogError = error
  },
  SET_CATEGORIES(state, categories) {
    state.categories = categories
  },
  SET_INTEGRATION_BY_SLUG(state, { slug, integration }) {
    state.integrationBySlug = {
      ...state.integrationBySlug,
      [slug]: integration,
    }
  },
}
